<template>
    <div ref="dom"></div>
</template>

<script>
import echarts from 'echarts'
import { on, off } from '@/utils/tools'
export default {
  name: 'serviceRequests',
  props: {
    option: {
      // type: Object,
      required: true
    },
  },
  data () {
    return {
      dom: null
    }
  },
  methods: {
    resize () {
      this.dom.resize()
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.dom = echarts.init(this.$refs.dom)
      this.dom.setOption(this.option)
      on(window, 'resize', this.resize)
    })
  },
  beforeDestroy () {
    off(window, 'resize', this.resize)
  },
  watch: {
    option(newValue) {
      this.dom = echarts.init(this.$refs.dom)
      this.dom.setOption(newValue)
      on(window, 'resize', this.resize)
    }
  },
}
</script>
